import { render } from "./LayoutPublic.vue?vue&type=template&id=520fbd66&ts=true"
import script from "./LayoutPublic.vue?vue&type=script&lang=ts"
export * from "./LayoutPublic.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__